import {createSlice} from "@reduxjs/toolkit";

const initialState = {
  mapCoordinates: {
    latitude: null,
    longitude: null
  },
  clubFinderListResult: null,
  isMapExpanded: false,
  toggleUserLocationFunction: false
}

const clubFinderMapResultSlice = createSlice({
  name: 'Club Finder Map Result',
  initialState,
  reducers: {
    setMapCoordinates(state, actions) {
      state.mapCoordinates = actions.payload;
    },
    setClubFinderListResult(state, action) {
      state.clubFinderListResult = action.payload;
    },
    setIsMapExpanded(state, actions) {
      state.isMapExpanded = actions.payload;
    },
    callGetUserLocationFunction(state, actions) {
      state.toggleUserLocationFunction = actions.payload;
    },
  },
})

export const clubFinderMapResultSliceActions = clubFinderMapResultSlice.actions;

export default clubFinderMapResultSlice.reducer;
